import VisibilityIcon from "@mui/icons-material/Visibility";
import { Grid, Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import { useCallback, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { MyComponentWithIconProps } from "../../components/Comman/IconButton";
import { LabelCompo } from "../../components/Comman/Label";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../components/withRouter";
import { titleColor } from "../../config/ColorObj";
import { noInternetMsg, serverMsg } from "../../config/messageconstant";
import { imageUrl } from "../../config/Url";
import { OutletEnquiryJson } from "../../DynamicFormsJson/MastersJSON/outletEnquiry";
import { apiGet } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";

const defaultGrid = {
    xs: 12,
    sm: 6,
    md: 6,
    lg: 6,
};

// 🔹 Reusable field builder
const buildFields = (viewData, fields) =>
    fields.map(({ label, key }) => ({
        ...defaultGrid,
        label,
        value: viewData?.[key] ?? "",
    }));

const OutletEnquiryView = (props) => {
    const { showLoador, showNotification, params } = props;

    const [viewData, setViewData] = useState({});
    const [isAdvanced, setIsAdvanced] = useState(0);

    // 🔹 Fetch Data
    useEffect(() => {
        const fetchData = async () => {
            if (!navigator.onLine) {
                showNotification({ msg: noInternetMsg, severity: "error" });
                return;
            }

            if (!params?.id) return;

            try {
                showLoador({ loador: true });

                const isAdvancedFlag =
                    localStorage.getItem("isShowAdvanceEnquiryMaster") ?? 0;

                setIsAdvanced(isAdvancedFlag);

                const { data, success } = await apiGet({
                    url: OutletEnquiryJson.isEditUrl + params.id,
                });

                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                    return;
                }

                setViewData(data?.data || {});
            } catch (error) {
                showNotification({ msg: serverMsg, severity: "error" });
            } finally {
                showLoador({ loador: false });
            }
        };

        fetchData();
    }, [params?.id, showLoador, showNotification]);

    // 🔹 Field Config (clean & maintainable)
    const advancedFields = [
        { label: "Business Name", key: "firmName" },
        { label: "Type Of Business", key: "businessType" },
        { label: "Contact Person Name", key: "ownerName" },
        { label: "Area", key: "address" },
        { label: "City", key: "villageCity" },
        { label: "State", key: "stateName" },
        { label: "What Are You Looking For?", key: "requirementType" },
        { label: "Products Looking For?", key: "productsLookingFor" },
        { label: "Initial Enquiry Assign To?", key: "enquiryAllocatedName" },
        { label: "Sales Person Contact No", key: "salesPersonContactNo" },
        { label: "Action Taken", key: "actionTaken" },
        { label: "Final Outcome", key: "outcomeStatus" },
        { label: "Added Date", key: "addedDate" },
    ];

    const basicFields = [
        { label: "Latitude", key: "latitude" },
        { label: "Longitude", key: "longitude" },
        { label: "Beat Name", key: "beatName" },
        { label: "Channel Name", key: "channelName" },
        { label: "Sub Channel Name", key: "subChannelName" },
        { label: "Outlet Type Name", key: "outletTypeName" },
        { label: "Firm Name", key: "firmName" },
        { label: "Owner Name", key: "ownerName" },
        { label: "Address", key: "address" },
        { label: "Added Date", key: "addedDate" },
        { label: "Potential", key: "potentialRateValue" },
        { label: "Platform", key: "enquiryRaisedPlatformName" },
    ];

    // 🔹 Memoized DataToSet
    const DataToSet = useMemo(() => {
        const fields = isAdvanced == 1 ? advancedFields : basicFields;
        return buildFields(viewData, fields);
    }, [viewData, isAdvanced]);

    // 🔹 Stable callback
    const onClickViewPreview = useCallback((row) => {
        window.open(imageUrl + row, "_blank");
    }, []);

    return (
        <Paper sx={{ p: 2, borderRadius: 0 }} elevation={0}>
            <DynamicFormWithoutSave
                showBackToList
                DataToSet={DataToSet}
                showTitle
                screenTitle={OutletEnquiryJson.viewTitle}
                fieldMeta={[]}
                apiBaseURL={OutletEnquiryJson.apiBaseURL}
                showSaveNextBtn={[]}
                showSaveBtnMain={false}
            />

            {viewData?.image && (
                <Grid
                    item
                    sm={6}
                    xs={12}
                    md={6}
                    lg={6}
                    container
                    justifyContent="flex-start"
                >
                    <Grid item xs={12} md={4.5} sm={4.5}>
                        <LabelCompo
                            className="text-black"
                            style={{
                                fontSize: 16,
                                color: titleColor,
                                marginLeft: "10px",
                            }}
                            label="Image :"
                        />
                    </Grid>
                    <Grid item xs={12} md={7.5} sm={7.5}>
                        <MyComponentWithIconProps
                            statusImage={VisibilityIcon}
                            color="primary"
                            fontSize="medium"
                            title="View"
                            onClick={() => onClickViewPreview(viewData.image)}
                        />
                    </Grid>
                </Grid>
            )}
        </Paper>
    );
};

export default compose(
    withRouter,
    connect(null, { showNotification, showLoador })
)(OutletEnquiryView);